<template>
    <div>
      <van-row class="text-center">
          <van-col span="8">
            <van-tag color="rgb(245, 66, 54)">当前已选中</van-tag>
          </van-col>
          <van-col span="8"><van-tag color="rgb(0, 129, 0)">可用媒体</van-tag></van-col>
          <van-col span="8"><van-tag color="rgb(182, 182, 183)">不可用</van-tag></van-col>
      </van-row>
      <p class="remark p-l-5 p-r-5 text-center">您可以点击红色选中媒体，查看广告投放详情</p>

      <van-row class="text-center">
          <van-col span="24" v-for="(item, index) in svgList" :key="index" >
              <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">
                {{stationTabLables[index].label}} <span class="text-red m-l-10" v-if="stationTabLables[index].quantity>0">{{stationTabLables[index].quantity}}块</span>
              </van-divider>
              <div v-html="item.svg" name="svgStationHtml" style="height:250px" class="svg-station-content" :id="'svgReview_' + index"></div>
          </van-col>
      </van-row>
    </div>
</template>

<script>
import '@vant/touch-emulator' // 用于解决web端模拟移动端的触摸事件
import mobileEvent from '@/utils/mobile'
import svgPanZoom from 'svg-pan-zoom'
import { Tag, Col, Row, Divider } from 'vant'
import { getStationSvgByStationId } from '@/api/station'
import { getOrderPublishInfoPage } from '@/api/msp'

export default {
  props: {
    orderId: {
      type: Number,
      required: true
    }
  },
  components: {
    [Tag.name]: Tag,
    [Col.name]: Col,
    [Row.name]: Row,
    [Divider.name]: Divider
  },
  data () {
    return ({
      chooseSchedule: '',
      svgList: [],
      stationTabLables: [],
      stationPublishInfo: [] // 站点发布信息
    })
  },
  created () {
    this.chooseSchedule = ''
    this.svgList = []
  },
  methods: {
    initDemandData (stationId, schedule) {
      this.chooseSchedule = schedule

      getStationSvgByStationId({ stationIds: stationId }).then(res => {
        this.svgList = res

        if (this.svgList.length > 0) {
          this.stationTabLables = []
          let label
          for (let index = 0; index < this.svgList.length; index++) {
            label = (this.svgList[index].floor > 0) ? '地上' : '地下'
            label += this.svgList[index].floor + '层' + this.svgList[index].positionName
            this.stationTabLables.push({
              label: label,
              quantity: 0
            })
          }

          this.initStationSvgResource(stationId)
        }
      })
    },
    initStationSvgResource (stationId) {
      // 获取上刊反馈
      let postData2 = {
        endDate: this.chooseSchedule.endDate,
        orderId: this.orderId,
        pageNumber: 1,
        pageSize: 200,
        startDate: this.chooseSchedule.startDate,
        stationId: stationId
      }

      getOrderPublishInfoPage(postData2).then(res => {
        this.$nextTick(() => {
          this.svgList.forEach((element, index) => {
            const currentSvgElement = document.getElementById('svgReview_' + index).firstElementChild
            // 设置svg呈现在画板上的尺寸
            currentSvgElement.setAttribute('width', '100%')
            currentSvgElement.setAttribute('height', '100%')

            svgPanZoom(currentSvgElement, {
              panEnabled: true,
              controlIconsEnabled: false,
              zoomEnabled: true,
              dblClickZoomEnabled: true,
              customEventsHandler: mobileEvent,
              minZoom: 1,
              maxZoom: 8,
              center: true
            })
          })

          this.formatSvgTaglable(res.list)
          this.tagResource(res.list)
        })
      })
    },
    tagResource (resourceBeanList) {
      if (resourceBeanList.length === 0) { return }

      this.stationPublishInfo = resourceBeanList
      const pathNodeList = document.getElementsByTagName('path')
      const gNodeList = document.getElementsByTagName('g')
      const deviceIds = resourceBeanList.map(x => x.deviceId)

      if (pathNodeList.length > 0) {
        for (let i = 0; i < pathNodeList.length; i++) {
          const el = pathNodeList[i]

          if (el.hasAttribute('data-id')) {
            // 判断灯箱点位是否包含在清单中
            const deviceId = parseInt(el.getAttribute('data-id'))
            if (deviceIds.indexOf(deviceId) > -1) {
              el.setAttribute('fill', '#F54236') // 红色
              el.setAttribute('cursor', 'pointer')
              // 注册点击事件，并调用父组件方法
              el.addEventListener('click', (e) => {
                this.handleClickDevice(deviceId)
              })
            }
          }
        }
      }

      // 新版地图使用g
      if (gNodeList.length > 0) {
        for (let j = 0; j < gNodeList.length; j++) {
          const newEl = gNodeList[j]
          if (newEl.hasAttribute('data-id')) {
            // 判断灯箱点位是否包含在清单中
            const deviceId = parseInt(newEl.getAttribute('data-id'))
            if (deviceIds.indexOf(deviceId) > -1) {
              newEl.setAttribute('fill', '#F54236') // 红色
              const gChild = newEl.children
              for (let k = 0; k < gChild.length; k++) {
                gChild[k].setAttribute('fill', '#F54236') // 红色
              }

              newEl.setAttribute('cursor', 'pointer')
              // 注册点击事件，并调用父组件方法
              newEl.addEventListener('click', (e) => {
                this.handleClickDevice(deviceId)
              })
            }
          }
        }
      }
    },
    handleClickDevice (deviceId) {
      let devicePublishInfo = this.stationPublishInfo.find(x => x.deviceId === deviceId)

      if (devicePublishInfo) {
        this.$emit('showDevicePublishInfo', devicePublishInfo)
      }
    },
    formatSvgTaglable (resourceBeanList) {
      const floorStatistic = []
      const distinctResource = []
      let floorStatisticBean

      resourceBeanList.forEach(element => {
        if (distinctResource.indexOf(element.deviceId) === -1) {
          distinctResource.push(element.deviceId)
          floorStatisticBean = floorStatistic.find(x => x.stationId === element.stationId && x.floor === element.floor)
          if (floorStatisticBean) {
            floorStatisticBean.quantity++
          } else {
            floorStatistic.push({
              stationId: element.stationId,
              floor: element.floor,
              quantity: 1
            })
          }
        }
      })

      // 开始重新格式化Tab标签
      let index = 0
      let floorStatisticBySvgHtml
      this.svgList.forEach(svgHtml => {
        floorStatisticBySvgHtml = floorStatistic.find(x => x.stationId === svgHtml.stationId && x.floor === svgHtml.floor)
        if (floorStatisticBySvgHtml) {
          this.stationTabLables[index].quantity = floorStatisticBySvgHtml.quantity
        }
        index++
      })

      this.stationTabLables = Object.assign({}, this.stationTabLables)
    }
  }
}
</script>
